var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWindCloud(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fill: "var(--color--primary-text)"
    },
    viewBox: "0 0 41.24 39.531",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -0.496)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.686,16.73a.433.433,0,0,1-.122-.375,7.9,7.9,0,0,0,.1-1.246,7.714,7.714,0,0,0-6.044-7.547.431.431,0,0,1-.294-.234A12.029,12.029,0,0,0,10.008,8.9a.431.431,0,0,1-.352.3A11.185,11.185,0,0,0,0,20.265a11.327,11.327,0,0,0,.1,1.5.435.435,0,0,0,.187.3.428.428,0,0,0,.344.06,4.263,4.263,0,0,1,1.088-.139h1.39a.426.426,0,0,0,.328-.151.421.421,0,0,0,.1-.344,7.733,7.733,0,0,1,7.774-8.956h0A1.718,1.718,0,0,0,13,11.1,8.592,8.592,0,0,1,29.581,9.671a1.718,1.718,0,0,0,1.547,1.146A4.3,4.3,0,0,1,34.963,16.6a1.718,1.718,0,0,0,.629,2.009A5.155,5.155,0,0,1,32.65,28H24.767a.43.43,0,0,0-.265.768,7.788,7.788,0,0,1,2.062,2.444.43.43,0,0,0,.378.225H32.65a8.592,8.592,0,0,0,6.037-14.7Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.718,20.81H14.606a5.155,5.155,0,1,0,0-10.31,1.718,1.718,0,1,0,0,3.437,1.718,1.718,0,1,1,0,3.437H1.718a1.718,1.718,0,1,0,0,3.437Z",
    transform: "translate(0 7.187)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.762,17.5H1.718a1.718,1.718,0,0,0,0,3.437H19.762a1.718,1.718,0,0,1,0,3.437,1.718,1.718,0,0,0,0,3.437,5.155,5.155,0,1,0,0-10.31Z",
    transform: "translate(0 12.216)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindCloud);
export default __webpack_public_path__ + "static/media/wind_cloud.c5c2d59ab6f6d7b6831706e034fc7f34.svg";
export { ForwardRef as ReactComponent };